export const DATA_MODE = (import.meta.env.VITE_DATA_MODE as string) || 'local';
export const API_URL = (import.meta.env.VITE_API_URL as string) || '';
export const isRemote = DATA_MODE === 'remote';
